export const ordersStatusesGroupCodes = {
    nod: "Ninguna orden entregada",
    aod: "Todas las ordenes entregadas",
    sod: "Algunas ordenes entregadas"
};

export const ordersStatusesGroupMessageClass = {
    nod: "text-theme-warning",
    aod: "text-success",
    sod: "text-info"
};
